import StrengthBar, { PasswordStrengthBarProps } from 'react-password-strength-bar';
import { useTheme } from 'styled-components';

type PasswordStrengthBar = PasswordStrengthBarProps;
export const PasswordStrengthBar = ({ password, onChangeScore }: PasswordStrengthBar) => {
    const { colors } = useTheme();
    if (!password) {
        return null;
    }

    return (
        // @ts-expect-error
        <StrengthBar
            minLength={6}
            password={password}
            onChangeScore={onChangeScore}
            shortScoreWord="Too short - please use a longer phrase, maybe something that's meaningful to you"
            scoreWordStyle={{
                textAlign: 'left'
            }}
            barColors={[colors.grey[400], colors.coral[700], colors.yellow[500], colors.royalBlue[500], colors.royalBlue[500]]}
            scoreWords={[
                "Too short - please use a longer phrase, maybe something that's meaningful to you",
                "Too short - please use a longer phrase, maybe something that's meaningful to you",
                'Almost there - add a few more words to make your password strong enough',
                'This password is great already, but you can still make it stronger by making it longer.',
                'Excellent password choice. Great job!'
            ]}
        />
    );
};
